import React from "react";

import { ModalPopup, ButtonsList } from "../../molecules";

const tr = require('ts-translate-js').default.boundTR;

interface PromoSelectorButtonsProps {
    container?: any,
    packages: Array<any>,
    onClose: (e: any) => void
}

export function PromoSelectorButtons({ container, packages, onClose }: PromoSelectorButtonsProps) {

    const buttonInfos = packages.map((item) => {
        return { class: "active btn-default", children: item.ProductPreferredName, onClick: (e: any) => { e.preventDefault(); parent.location.href = item.ProductInfoURL; } };
    });

    return <ModalPopup
        container={container}
        title={tr("Choisissez votre promotion")}
        onClose={onClose}
    >
        <hr />
        <ButtonsList buttonInfos={buttonInfos} />
    </ModalPopup>;
}